import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.css'
import App from './App'
import preload from './preload'

const render = () => {
  ReactDOM.render(<App />, document.getElementById('root'))
}
preload(render)



// WEBPACK FOOTER //
// ./src/index.js